import { useEffect, useState } from 'react';
import axios from 'axios';
import { RefreshCw, ShieldCheck, ShieldAlert } from 'lucide-react';
import { ORIGIN, TOKEN_KEY, message } from '../api';

export const PaymentConnection = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true); setError(''); setData(null);
    try {
      const response = await axios.get(`${ORIGIN}/api/admin/payments/config`, {
        headers: { Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` },
      });
      setData(response.data);
    } catch (e) { setError(message(e)); }
    finally { setBusy(false); }
  };
  useEffect(() => { load(); }, []);
  return <section className={`ar-alert ${error || (data && !data.ready) ? 'error' : ''}`} data-testid="payment-connection">
    <div className="ar-admin-heading">
      <h2>{data?.ready ? <ShieldCheck size={18}/> : <ShieldAlert size={18}/>} Stripe 결제 연결</h2>
      <button className="ar-btn outline small" disabled={busy} onClick={load} aria-label="결제 연결 확인" data-testid="payment-connection-refresh"><RefreshCw size={15}/></button>
    </div>
    {busy && <p data-testid="payment-connection-loading">실제 결제 계정 확인 중…</p>}
    {error && <p role="alert" data-testid="payment-connection-error">{error}</p>}
    {data && <>
      <strong data-testid="payment-connection-status">{data.ready ? `라이브 · ${data.account_name || 'Stripe'}` : '결제 연결 차단'}</strong>
      <p data-testid="payment-connection-detail">{data.ready ? 'BBQ · 소개팅 · 모든 신규 이벤트 / 실제 카드 결제' : data.message}</p>
    </>}
  </section>;
};